<ng-container>
    <!-- <div class="ms-auto filter-div">
        <button type="button" class="btn btn-outline-primary" (click)="refreshConversations();" ngbTooltip="Refresh" aria-label="Refresh">
            <fa-icon [icon]="faRotateRight" [spin]="isLoading"></fa-icon>
        </button>
        <span class="ms-2"></span>
        <ng-container *ngTemplateOutlet="SORT_DROPDOWN"></ng-container>
        <span class="ms-2"></span>
        <ng-container *ngTemplateOutlet="FILTER_DROPDOWN"></ng-container>
    </div> -->
    <div class="row">
        <div class="col-md-6">
            <button (click)="newChat()" class="btn btn-primary w-100" type="button">
                <fa-icon class="menu-icon" [icon]="faSms"></fa-icon>
                <span class="web-display">New SMS</span>
            </button>
        </div>
        <div class="col-md-6">
            <button (click)="openCallDialerDialog()" class="btn btn-primary w-100" type="button">
                <fa-icon class="menu-icon" [icon]="faPhone"></fa-icon>
                <span class="web-display">New Call</span>
            </button>
        </div>
    </div>
    <div class="mt-2 filter-div">
        <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" (keyup)="searchContacts($event.target.value)" [(ngModel)]="searchContact" #searchInput>
        </div>
    </div>
    <div class="overflow-auto message-list" *ngIf="conversationListFiltered && conversationListFiltered.length !=0; else noList">
        <ul class="list-group">
            <li class="list-group-item list-group-item-action user-list" *ngFor="let conversation of conversationListFiltered; let i = index" (click)="setSelectedConversation(conversation)" [class.selected]="selectedId == conversation.id">
                <div class="py-2 cursor-pointer">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex text-break">
                                <h5>{{conversation.name.trim() ? conversation.name : "No Contact"}}
                                    <span *ngIf="countUnreadMessages(conversation) > 0" class="message-badge">
                                        {{countUnreadMessages(conversation)}}
                                    </span>
                                </h5>
                                <div [ngClass]="{'mt-2': !isMobileDevice}" class="ms-auto mt-xl-0">
                                    <button [ngbPopover]="moreOptionsPopOver" #moreOptions="ngbPopover" (click)="$event.stopPropagation(); popOverOptions(moreOptions, conversation);" triggers="manual" autoClose="outside" class="btn btn-primary ms-2" type="button">
                                        <fa-icon class="button-icon-center" [icon]="faEllipsis"></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <p>{{formatPhoneNumber(conversation.clientNumber)}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <p class="last-conversation mb-0 p-0" style="word-wrap: break-word;">
                            {{ conversation.lastConversation }}
                        </p>
                    </div>
                    <div class="row text-end">
                        <span class="small-date">{{ conversation.date * 1000 | date : 'MM-dd-yyyy' }}</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>

</ng-container>
<ng-template #noList>
    <!-- TODO Add no list -->
    <h4>No Conversation List</h4>
</ng-template>

<!-- Sort Dropdown -->
<ng-template #SORT_DROPDOWN>
    <div ngbDropdown class="d-inline-block" [autoClose]="true">
        <button class="btn btn-outline-primary" ngbDropdownToggle ngbTooltip="Sort" aria-label="Sort">
            <fa-icon [icon]="faSortAmountDownAlt"></fa-icon>
        </button>
        <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="setSort('createdAt');">
                Created
                <fa-icon *ngIf="sortBy == 'createdAt'" [icon]="(sortDirection == 'ASC' ? faSortDown : faSortUp)" class="sortButton"></fa-icon>
            </button>
        </div>
    </div>
</ng-template>

<!-- Filter Dropdown -->
<ng-template #FILTER_DROPDOWN>
    <div ngbDropdown class="d-inline-block" autoClose="outside">
        <span *ngIf="selectedFilters.length > 0" class="custom-badge-lg">{{selectedFilters.length}}</span>
        <button class="btn btn-outline-primary" ngbDropdownToggle ngbTooltip="Filter" aria-label="Filter">
            <fa-icon [icon]="faFilter"></fa-icon>
        </button>
        <div ngbDropdownMenu>
            <!-- Status -->
            <button ngbDropdownItem (click)="statusCollapse.toggle();">Status</button>
            <div class="px-4 py-1" #statusCollapse="ngbCollapse" [ngbCollapse]="true">
                <div class="d-flex flex-column">
                    <div *ngFor="let element of columnFilterValues.get('status');" class="form-check form-check-inline">
                        <input [id]="element.value" class="form-check-input" [checked]="checkIfSelected(element)" type="checkbox" (change)="addRemoveFilter('status', element.value);">
                        <label [for]="element.value" class="form-check-label" style="white-space: nowrap;">{{element.name}}</label>
                    </div>
                </div>
            </div>
            <!-- Divider -->
            <div class="dropdown-divider"></div>
            <!-- Reset -->
            <button ngbDropdownItem (click)="resetActiveFilters(); statusCollapse.toggle();">Reset</button>
        </div>
    </div>
</ng-template>

<ng-template #moreOptionsPopOver let-popover="popover" let-contact="res">
    <div class="d-flex flex-column gap-2">
        <button (click)="openCallDialerDialog(contact)" class="btn btn-sm btn-primary" type="button">
            <fa-icon class="button-icon-left" [icon]="faPhone"></fa-icon>
            <span>Call</span>
        </button>
        <button (click)="openEmailDialog(contact)" class="btn btn-sm btn-primary" type="button">
            <fa-icon class="button-icon-left" [icon]="faEnvelope"></fa-icon>
            <span>Email</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary" routerLink="/clients/{{contact?.clientId}}">
            <fa-icon [icon]="faUser" class="button-icon-left"></fa-icon>
            <span>Profile</span>
        </button>
    </div>
</ng-template>
